module.exports = __webpack_public_path__ + "img/open-left.40096734.svg";